<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
<template>
  <div>
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="6">
          <b-form-group label="Transaction Type*" label-for="trxType">
            <b-form-select id="trxType" name="trxType" v-model="transaction.type" :options="typesDLL" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Transaction Date*" label-for="trxDate">
            <b-form-datepicker id="trxDate" v-model="transaction.date" class="mb-1" />
          </b-form-group>
        </b-col>
        <b-col cols="6" v-if="showFromWarehouse">
         <b-form-group label="From Warehouse*" label-for="fromWarehouse">
           <b-form-select
            id="fromWarehouse"
            name="fromWarehouse"
            v-model="transaction.fromWarehouse"
            :options="warehouses"
            value-field="id"
            text-field="name"
          >
           <option value="">None</option>
          </b-form-select>
         </b-form-group>
        </b-col>

      <b-col md="6" v-if="showToWarehouse">
        <b-form-group label="To Warehouse" label-for="toWarehouse">
         <b-form-select
          id="toWarehouse"
          name="toWarehouse"
          v-model="transaction.toWarehouse"
          :options="warehouses"
          value-field="id"
         text-field="name"
        >
        <option value="">None</option>
        </b-form-select>
        </b-form-group>
      </b-col>
        <b-col cols="12" class="mb-2">
          <label for="trxRef">Transaction Reference</label>
          <b-form-textarea id="trxRef" name="trxRef" placeholder="Transaction Reference" rows="3"
            v-model="transaction.refNo" />
        </b-col>
      </b-row>
    </b-form>
    <b-form ref="form" :style="{ height: trHeight }" class="repeater-form" @submit.prevent="addLine">
      <b-row>
        <b-col md="3">
          <b-input-group>
            <b-form-input v-model="barcode" placeholder="Enter Barcode" @keydown.enter="addItemWithBarcode" />
            <b-input-group-append is-text>
              <feather-icon icon="CastIcon" />
            </b-input-group-append>
          </b-input-group>

          <b-modal id="modal-barcode" title="Select Product" ok-only ok-title="Cancel" centered>
            <b-row v-for="(product, index) in selectedProduct" :key="product.id" class="mb-2">
              <b-col cols="8">
                <!-- Display product name -->
                <b-card-text class="mb-0">{{ product.name }}</b-card-text>
              </b-col>
              <b-col cols="4" class="text-right">
                <!-- Select button -->
                <b-button variant="primary" @click="addProductFromModal(product.id)">Select</b-button>
              </b-col>
            </b-row>
          </b-modal>


        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>
      <b-row v-for="(item, index) in transaction.inventoryTransactionLine" :id="item.serial" :key="item.serial"
        ref="row">
        <b-col md="3">
          <b-form-group label="Product / Raw Material*" label-for="itemId">
            <v-select v-model="item.itemId" id="itemId" :options="filteredItems" label="name"
              placeholder="Search Product / Raw Material" @search="filterItems" @input="itemChanged(item)"/>

          </b-form-group>
        </b-col>
        <!-- Quantity -->
        <!-- <b-col md="2">
          <b-form-group label="Unit of Measure*" label-for="itemUom">
            <b-form-select v-model="item.uomId" id="itemUom" name="itemUom" :options="itemUoms" value-field="id"
              text-field="name" />
          </b-form-group>
        </b-col> -->
        <b-col md="2">
          <b-form-group label="Qty*" label-for="itemQty">
            <b-form-input v-model="item.qty" id="itemQty" name="itemQty" type="number" required min="1" max="100"
              placeholder="" />
          </b-form-group>
        </b-col>
        <!-- Remove Button -->
        <b-col lg="3" md="3" class="mb-50">
          <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-0 mt-md-2"
            @click="removeLine(index)">
            <feather-icon icon="XIcon" class="mr-25" />
            <span>Delete</span>
          </b-button>
        </b-col>
        <b-col cols="12">
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="addLine" :disabled="loading ||
            productLoading ||
            materialLoading ||
            uomLoading ||
            warehouseLoading
            ">
            <feather-icon icon="PlusIcon" class="mr-25" />
            <span>Add Line</span>
          </b-button>
        </b-col>
      </b-row>
    </b-form>
    <b-row>
      <b-col cols="12" style="text-align: right">
        <b-button variant="outline-primary" class="btn btn-primary" @click="addTransaction()"><b-spinner small v-if="
          loading ||
          productLoading ||
          materialLoading ||
          uomLoading ||
          warehouseLoading
        " class="mx-2" />Save and Post</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormSelect,
  BFormInput,
  BFormTextarea,
  BFormDatepicker,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
} from "bootstrap-vue";

import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import { fnSortingDropdown } from "@/libs/customFn";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BFormTextarea,
    BFormDatepicker,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    vSelect
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      filteredItems: [],
      barcode: null,
      selectedProduct: [],
      items: [],
      types: [
        { value: 1, text: "PURCHASE" },
        // { value: 2, text: "PRODUCTION" },
        { value: 3, text: "SALES" },
        { value: 4, text: "RETURN" },
        { value: 5, text: "DEFECT" },
        { value: 6, text: "LOST" },
        { value: 7, text: "STOLEN" },
        { value: 8, text: "TRANSFER" },
      ],
      warehouseVisibilityRules: {
      1: { from: false, to: true },  // PURCHASE: Only "To Warehouse"
      3: { from: true, to: false }, // SALES: Only "From Warehouse"
      4: { from: false, to: true },  // RETURN: Only "To Warehouse"
      5: { from: true, to: false }, // DEFECT: Only "From Warehouse"
      6: { from: true, to: false }, // LOST: Only "From Warehouse"
      7: { from: true, to: false }, // STOLEN: Only "From Warehouse"
      8: { from: true, to: true },  // TRANSFER: Both warehouses
    },
      transaction: {
        type: null,
        fromWarehouse: "",
        toWarehouse: "",
        date: new Date(),
        refNo: null,
        posted: true,
        postedDate: new Date(),
        inventoryTransactionLine: [],
      },
      nextSerial: 0,
    };
  },
  methods: {
    ...mapActions("inventoryTransactionModule", ["addTransactionAction"]),
    ...mapActions("productModule", ["getProductListAction"]),
    ...mapActions("rawmaterialModule", ["getRawMaterialListAction"]),
    ...mapActions("itemUomModule", ["getItemUOMListAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    addLine() {
      let line = {
        serial: this.nextSerial,
        itemId: null,
        uomId: null,
        qty: 0,
      };
      this.transaction.inventoryTransactionLine.push(line);
      this.nextSerial += 1;

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeLine(index) {
      this.transaction.inventoryTransactionLine.splice(index, 1);
      this.transaction.inventoryTransactionLine.forEach((x, index) => {
        x.serial = index;
      });
      this.nextSerial -= 1;
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    filterItems(search) {
      if (!search) {
        // Reset to all items if no search query
        this.filteredItems = this.items;
      } else {
        // Filter items dynamically based on search query
        const lowerSearch = search.toLowerCase();
        this.filteredItems = this.items.filter((item) => {
      // Safeguard against missing "name" properties
          return item.name && item.name.toLowerCase().includes(lowerSearch);
        });
      }
    },
    itemChanged(item) {
  let selectedItem = this.items.find((obj) => obj.id === item.itemId.id || obj.id === item.itemId);
  if (selectedItem) {
    item.itemId = { id: selectedItem.id, name: selectedItem.name }; // Store full object
    item.uomId = selectedItem.defaultUomID;
  }
},
    created() {
      window.addEventListener("resize", this.initTrHeight);
    },
    destroyed() {
      window.removeEventListener("resize", this.initTrHeight);
    },
    addTransaction() {
      let isValid = true;
      if (!this.transaction.type) {
        this.showMessage(
          "error",
          "Inventory Transaction",
          "You must choose transaction type!"
        );
        isValid = false;
      } else if (
        !this.transaction.fromWarehouse &&
        !this.transaction.toWarehouse
      ) {
        this.showMessage(
          "error",
          "Inventory Transaction",
          "You must choose from warehouse or to warehouse or both!"
        );
        isValid = false;
      } else if (this.transaction.inventoryTransactionLine.length === 0) {
        this.showMessage(
          "error",
          "Inventory Transaction",
          "Please input at least 1 line item!"
        );
        isValid = false;
      } else {
        this.transaction.inventoryTransactionLine.forEach((x) => {
          if (!x.itemId || (x.qty <= 0) || (x.qty ?? 0) === 0) {
            this.showMessage(
              "error",
              "Inventory Transaction",
              "Please check line item " +
              (parseInt(x.serial) + 1) +
              ". The product is required and Qty should be more than zero."
            );
            isValid = false;
          }
        });
      }
      if (isValid) {
    // ✅ Convert itemId from object to just the ID before submitting
    const payload = {
      ...this.transaction,
      fromWarehouse: this.transaction.fromWarehouse || null, // Convert empty string to null
      toWarehouse: this.transaction.toWarehouse || null,     // Convert empty string to null
      inventoryTransactionLine: this.transaction.inventoryTransactionLine.map((x) => ({
        ...x,
        serial: String(x.serial), // ✅ Convert serial to a string
        itemId: x.itemId.id,  // ✅ Extract only ID for backend submission
      })),
    };
    console.log("payload", payload);

    this.addTransactionAction(payload)
      .then(() => {
        this.success();
      })
      .catch((ex) => {
        this.error(ex.response.data);
      });
  }
    },
    showMessage(icon, title, msg, reRoute) {
      this.$swal({
        title: title,
        text: msg,
        icon: icon,
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value && reRoute) {
          this.$router.push({ name: reRoute });
        }
      });
    },
    addItemWithBarcode() {
      if (!this.barcode) {
        return;
      }
      if (!this.items || this.items.length === 0) {
        console.warn('Items list is not initialized or empty.');
        return;
      }

      // Filter products by barcode
      let products = this.ProductList.filter((x) => x.barcode === this.barcode);

      // Log the products found for debugging
      console.log('Products found with barcode:', this.barcode, products);

      // If more than one product is found, show the modal with radio buttons
      if (products && products.length > 1) {
        this.selectedProduct = products;

        // Map products to radio button options
        this.productOptions = products.map((product) => ({
          text: product.name,
          value: product.id,
        }));

        // Show the modal to select a product
        this.$bvModal.show("modal-barcode");
      } else if (products.length === 1) {
        // If only one product is found, add it directly to the transaction
        let productDetail = products[0];


        let index = this.transaction.inventoryTransactionLine.length - 1;
        if (index >= 0 && this.transaction.inventoryTransactionLine[index].itemId == undefined) {
          this.transaction.inventoryTransactionLine.splice(index, 1);
        }



        // Log the product id
        console.log('Product ID found:', productDetail);

        // Add a new transaction line with the product details
        let newLine = {
          serial: this.nextSerial,
          itemId: { id: productDetail.id, name: productDetail.name }, // Set the item ID for the dropdown
          uomId: productDetail.defaultUomId || null, // Prefill the unit of measure if available
          qty: 1, // Set the quantity to 1
        };

        this.transaction.inventoryTransactionLine.push(newLine);
        this.nextSerial += 1;

        // Ensure the form height adjusts accordingly
        this.$nextTick(() => {
          if (this.$refs.row && this.$refs.row[0]) {
            this.trAddHeight(this.$refs.row[0].offsetHeight);
          }
        });

        // Log the product detail being added for debugging
        console.log('Added product to transaction line:', newLine);
      } else {
        // Log a message if no products are found
        console.log('No products found for barcode:', this.barcode);
      }

      // Clear the barcode field
      this.barcode = null;
    },
    addProductFromModal(selectedProductId) {
      // Find the selected product from the ProductList
      let selectedProduct = this.ProductList.find(
        (product) => product.id === selectedProductId
      );

      if (selectedProduct) {
        // Create a new line object with the selected product details
        let newLine = {
          serial: this.nextSerial, // Ensure unique serial for the line
          itemId: selectedProduct.id, // Set the item ID
          uomId: selectedProduct.defaultUomId || null, // Prefill unit of measure if available
          qty: 1, // Set default quantity to 1
        };

        // Push the new line to the inventoryTransactionLine array
        this.transaction.inventoryTransactionLine.push(newLine);
        this.nextSerial += 1; // Increment serial number for the next item

        // Hide the modal
        this.$bvModal.hide("modal-barcode");

        // Adjust form height (if applicable)
        this.$nextTick(() => {
          if (this.$refs.row && this.$refs.row[0]) {
            this.trAddHeight(this.$refs.row[0].offsetHeight);
          }
        });
      }
    },
    success() {
      this.$swal({
        title: "Inventory Transactions",
        text: "You have successfully added the transaction!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$router.push({ name: "inventory-transaction-list" });
        }
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += "Duplicate line item";
        msg += "</div>";
      }
      return msg;
    },
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    showFromWarehouse() {
    if (!this.transaction.type) return false;
    return this.warehouseVisibilityRules[this.transaction.type]?.from || false;
  },
  showToWarehouse() {
    if (!this.transaction.type) return false;
    return this.warehouseVisibilityRules[this.transaction.type]?.to || false;
  },
    ...mapGetters("inventoryTransactionModule", {
      loading: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      productLoading: "loading",
    }),
    ...mapGetters("rawmaterialModule", {
      RawMaterialList: "rawmaterials",
      materialLoading: "loading",
    }),
    ...mapGetters("itemUomModule", {
      itemUoms: "itemuom",
      uomLoading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      rawwarehouses: "warehouse",
      warehouseLoading: "loading",
    }),
    warehouses() {
      return this.rawwarehouses
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    typesDLL() {
      return fnSortingDropdown(this.types);
    },
  },
  watch: {
  "transaction.type"(newType) {
    if (newType) {
      
      this.transaction.fromWarehouse = "";
      this.transaction.toWarehouse = "";

    }
  },
},

  async mounted() {
    this.initTrHeight();
    await this.getWarehouseListAction();
    await this.getProductListAction(true).then(() => {
      const uniqueItems = new Set();
      this.ProductList.forEach((x) => {
        if (x && !uniqueItems.has(x.id)) {
          this.items.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomId,
          });
          uniqueItems.add(x.id);
        }
      });
    });
    await this.getRawMaterialListAction().then(() => {
      const uniqueItems = new Set(this.items.map((item) => item.id));
      this.RawMaterialList.forEach((x) => {
        if (x && !uniqueItems.has(x.id)) {
          this.items.push({
            id: x.id,
            name: x.name,
            defaultUomID: x.defaultUomID,
          });
          uniqueItems.add(x.id);
        }
      });
    });
    this.items = fnSortingDropdown(this.items, "asc", "name");
    this.filteredItems = this.items;
    await this.getItemUOMListAction();
    this.addLine();

  },
};
</script>

<style lang="scss" scoped>
::v-deep .vs__dropdown-menu {
  width: 100% !important; 
  min-width: 300px;    
  max-height: 275px;     
  overflow-y: auto;      
  position: absolute;   
  z-index: 1050;       
  background-color: white; 
  border: 1px solid #dcdcdc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); 
  border-radius: 4px;    
}

::v-deep .vs__dropdown-toggle {
  width: 100% !important; 
}

.repeater-form {
  position: relative; 
  overflow: visible !important; 
}
</style>
